module.exports = __webpack_public_path__ + "static/media/Icons_Logout.f706787c.svg";